import { InspectionItemType } from '../interfaces/inspectionItem';
/**
 * Default labels for inspection item types.
 */
export const INSPECTION_ITEM_DEFAULT_NAMES = {
    [InspectionItemType.Volume]: '体積',
    [InspectionItemType.PolygonArea]: '面積',
    [InspectionItemType.PolylineLength]: '延長',
    [InspectionItemType.LengthWithDistanceTool]: '距離',
};
